import React from 'react';
import { ConsiderationLedger } from '../../../../../components/FlowOfFunds/ConsiderationLedger/ConsiderationLedger';
import { useFlowOfFunds } from '../useFlowOfFunds';

export interface OverallDealStructureSubTabProps {
    engagementId: number;
}

/** Purchase Price Consideration — the consideration summary ledger plus the
 *  per-type Consideration Detail tables. */
export const OverallDealStructureSubTab = (props: OverallDealStructureSubTabProps) => {
    const { flowOfFunds, isLoading } = useFlowOfFunds(props.engagementId);

    if (isLoading) {
        return <div className="mt-4 text-muted">Loading…</div>;
    }
    if (!flowOfFunds?.consideration) {
        return (
            <div className="mt-4 text-muted">
                No consideration has been recorded for this engagement yet.
            </div>
        );
    }

    return (
        <div className="mt-4">
            <ConsiderationLedger consideration={flowOfFunds.consideration} />
        </div>
    );
};

export default OverallDealStructureSubTab;
